export default __webpack_public_path__ + "static/media/logo_horizontal_fasting.fbce9880.svg";